import React, {
  useState,
  useEffect
} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Typography,
  CircularProgress,
  FormControl,
  FormHelperText,
  InputLabel,
  Input,
  Button,
  TextField,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import {
  BaseAPI,
} from '../../../data/BaseAPI';

import localization from '../../../utils/localizations';
import logo from '../../../img/logo.png';
import loginBg from '../../../img/login-bg.jpg';


const useStyles = makeStyles((theme) => ({
  mainBg: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${loginBg})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  },
  mainBody: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backdropFilter: 'blur(3px)',
  },
  loginContainer: {
    padding: 10,
    width: 320,
    textAlign: 'center',
    backgroundColor: 'rgba(255,255,255,.777)',
    backdropFilter: 'blur(9px)',
  },
  appLogo: {
    width: 100,
    height: 100,
  },
  loginText: {
    margin: 20,
  },
  loginForm: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    }
  },
  formButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 10,
    paddingRight: 10,
    marginTop: 10,
  },
  errorContainer: {
    padding: 10,
    textAlign: 'left',
  },
  formHelperText: {
    marginLeft: 10,
    marginRight: 10,
  }
}));
 

function Login(props: {languageSelectorEl: any, onLogin: any}) {
  const classes = useStyles();

  const [loginResult, setLoginResult] = useState(undefined as {success: boolean; errors?: string[]|undefined}|undefined);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showVerificationCodeField, setShowVerificationCodeField] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");

  const doLogin = async (e: any) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!username || !password) return;

    const api = new BaseAPI();
    const data = new FormData();
    data.append('username', username);
    data.append('password', password);
    if (showVerificationCodeField) data.append('verification_code', verificationCode);

    setIsLoading(true);
    try {
      const [result, response, error] = await api.post(data, 'login/');
      console.log(result);
      setLoginResult(result);

      if (result && result.success && props.onLogin) props.onLogin();
      if (result && !result.success && result.requires_2fa_challange) setShowVerificationCodeField(true);
    } catch (error) {
      console.error(error);
    }
    
    setIsLoading(false);
  };

  let errors = null;
  if (loginResult && loginResult.errors) {
    const errorsList = loginResult.errors.map((error: string, i: number) => <Alert key={`error-${i}`} severity="error">{error}</Alert>);
    errors = <div className={classes.errorContainer}>{errorsList}</div>
  }

  return (
    <div className={classes.mainBg}>
      <div className={classes.mainBody}>
        <Paper className={classes.loginContainer}>
          <img src={logo} width="100" height="100" alt="" className={classes.appLogo} />
          <Typography variant="body1" className={classes.loginText}>{localization.appTitle}</Typography>
          
          {props.languageSelectorEl}

          <form action="" className={classes.loginForm} onSubmit={doLogin}>
            {!showVerificationCodeField &&
              <FormControl fullWidth>
                <TextField
                  id="username"
                  label="NIM / Email"
                  autoComplete="username"
                  variant="outlined"
                  value={username}
                  onChange={(e: any) => setUsername(e.target.value.substring(0, 255))}
                />
              </FormControl>
            }
            {!showVerificationCodeField &&
              <FormControl fullWidth>
                <TextField
                  id="password"
                  label="Password"
                  type="password"
                  autoComplete="current-password"
                  variant="outlined"
                  value={password}
                  onChange={(e: any) => setPassword(e.target.value.substring(0, 255))}
                />
              </FormControl>
            }
            {showVerificationCodeField &&
              <FormControl fullWidth>
                <TextField
                  id="verification_code"
                  label={localization.verificationCode}
                  autoComplete="one-time-code"
                  variant="outlined"
                  value={verificationCode}
                  onChange={(e: any) => setVerificationCode(e.target.value.substring(0, 255))}
                />
                <FormHelperText className={classes.formHelperText}>{localization.login2faMessage}</FormHelperText>
              </FormControl>
            }

            {errors}

            <div className={classes.formButtonContainer}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={doLogin}
                disabled={isLoading}
              >{isLoading ? localization.loading : localization.login}</Button>
              <Button
                size="small"
                onClick={() => window.open("/accounts/password_reset/")}
              >{localization.forgotPassword}</Button>
            </div>
          </form>
        </Paper>
      </div>
    </div>
  );
}

export {Login};